module.exports = __webpack_public_path__ + "154a7084fc1ba6f40bda56f5f4bc6f18.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/map/4.png
// module id = 1351
// module chunks = 0